import { useEffect, useState } from "react";
import { findAnchor } from "./anchor.js";
import type { ReceivedActivity } from "./usePresence.js";

const MARK_MS = 8000;

export function ActivityMarks({
  activity,
  me,
}: {
  activity: ReceivedActivity[];
  me: string | null;
}) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setTick((n) => n + 1), 500);
    return () => clearInterval(t);
  }, []);
  const now = Date.now();
  const latest = new Map<string, ReceivedActivity>();
  for (const a of activity) {
    if (a.username === me || now - a.at > MARK_MS) continue;
    latest.set(a.target, a);
  }
  return (
    <div className="pointer-events-none fixed inset-0 z-[55]">
      {[...latest.values()].map((a) => {
        const el = findAnchor(a.target);
        if (!el) return null;
        const r = el.getBoundingClientRect();
        return (
          <div
            key={a.id}
            className="absolute rounded-lg"
            style={{
              left: r.left - 3,
              top: r.top - 3,
              width: r.width + 6,
              height: r.height + 6,
              boxShadow: `0 0 0 2px ${a.color}`,
            }}
          >
            <span
              className="absolute -top-5 left-0 whitespace-nowrap rounded px-1.5 py-0.5 text-[10.5px] font-semibold text-white shadow"
              style={{ backgroundColor: a.color }}
            >
              {a.username} · {a.verb} · {Math.max(0, Math.round((now - a.at) / 1000))} s
            </span>
          </div>
        );
      })}
    </div>
  );
}
